module.exports = __webpack_public_path__ + "img/molibogov.83976d2a.jpg";